<template>
    <div class="home">
        <calendar-task
            style="background-color: white"
            @date-change="dateChange"
            @item-click="itemClick"
            :date="date"
            :UserInfo="UserInfo"
            v-model="calendarData"
            Working="true"
            @operating-click="operatingClick"
            @delete-item="deleteItem"
            @WorkingApprove-change="WorkingApprove"
        ></calendar-task>

        <a-modal
            title="工时填报"
            okText="提交"
            cancelText="取消"
            :visible="openWorking"
            :confirm-loading="confirmLoading"
            @ok="operatingSubmitWorking"
            @cancel="closeWorking"
        >
            <div class="warning" v-if="formWorking.State == -1">拒绝原因: {{ formWorking.approvalContent }}</div>
            <a-form :model="form" layout="vertical">
                <a-form-model-item label="姓名:">
                    <a-select
                        v-model="formWorking.UserCode"
                        show-search
                        option-filter-prop="children"
                        placeholder="请选择研发人员"
                    >
                        <a-select-option v-for="d in users" :key="d.value">
                            {{ d.value + '[' + d.text + ']' }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="所属项目">
                    <a-select
                        v-model="formWorking.ProjectCode"
                        show-search
                        option-filter-prop="children"
                        placeholder="请选择所属项目"
                    >
                        <a-select-option v-for="d in projects" :key="d.value">
                            {{ d.value + '[' + d.text + ']' }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="开始时间">
                    <a-date-picker v-model="formWorking.StartTime" />
                </a-form-model-item>
                <a-form-model-item label="时间段">
                    <a-row>
                        <a-col :span="11">
                            <a-select v-model="formWorking.timeFrom" placeholder="请选择时间">
                                <a-select-option v-for="d in timeFromOptions" :key="d.key" :value="d.value">
                                    {{ d.label }}
                                </a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :span="2" style="text-align: center">~</a-col>
                        <a-col :span="11">
                            <a-select v-model="formWorking.timeTo" placeholder="请选择时间">
                                <a-select-option v-for="d in timeToOptions" :key="d.key" :value="d.value">
                                    {{ d.label }}
                                </a-select-option>
                            </a-select>
                        </a-col>
                    </a-row>
                </a-form-model-item>
                <a-form-model-item label="工时(小时数)">
                    <a-input-number v-model="formWorking.Duration" :disabled="true" />
                </a-form-model-item>

                <a-form-model-item label="Activity">
                    <a-input v-model="formWorking.activity" :disabled="true" />
                </a-form-model-item>
                <a-form-model-item label="工作内容">
                    <a-input v-model="formWorking.WMContent" type="textarea" />
                </a-form-model-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script lang="js">
import calendarTask from '@/components/CalendarTask.vue';

export default {
    name: "Project",
    components: {
        calendarTask
    },
    props: {
        title: { type: String },
    },
    data: () => ({
        date: new Date(),
        calendarData: [],
        openWorking: false,
        confirmLoading:false,
        visible: false,
        openModalclass: '',
        loading:true,
        calendarDate:'',
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
        projects: [],
        users: [],

        //工时提交信息
        formWorking: {
            UserName: '',
            UserCode: '',
            ProjectCode: '',
            StartTime: '',
            timeFrom: '',
            timeTo: '',
            Duration: 0,
            WMContent: '',
            approvalContent: '',
            activity: ''
        },
        form:[],
        UserInfo:null,
        timeFrom: 80,
        timeTo: 200,
    }),
    created() {
    },
    watch: {
        'formWorking.timeFrom'(){
            if(this.formWorking.timeFrom && this.formWorking.timeTo){
                this.formWorking.Duration = (this.formWorking.timeTo - this.formWorking.timeFrom) / 10
            } else {
                this.formWorking.Duration = 0
            }
        },
        'formWorking.timeTo'(){
            if(this.formWorking.timeFrom && this.formWorking.timeTo){
                this.formWorking.Duration = (this.formWorking.timeTo - this.formWorking.timeFrom) / 10
            } else {
                this.formWorking.Duration = 0
            }
        }
    },
    computed: {
        timeFromOptions() {
            return this.getTimeOptions(this.timeFrom,this.timeTo)
        },
        timeToOptions() {
            let timeFrom = this.timeFrom
            if(this.formWorking.timeFrom){
                timeFrom = this.formWorking.timeFrom + 5
            }
            return this.getTimeOptions(timeFrom, this.timeTo)
        }
    },
    methods: {
        getTimeOptions(timeFrom,timeTo){
            let options = []
            for(let time = timeFrom; time <= timeTo; time+=5){
                if(time % 10 == 0){
                    options.push({
                        key: 'b' + time,
                        value: time,
                        label: time / 10 + ':00'
                    })
                } else {
                    options.push({
                        key: 'b' + time,
                        value: time,
                        label: Math.floor(time / 10) + ':30'
                    })
                }
            }
            return options
        },
        itemClick(item) {
            console.log(item);
        },
        //回调
        operatingClick(date, item){ //item 工时 ID值
            if(item){
                //如果传入ID值则查询
                this.$axios.get('/api/Working/GetWorkingData?ID=' + item ).then(d => {
                    this.formWorking.UserName = d.data.UserName;
                    this.formWorking.UserCode = d.data.UserCode;
                    this.formWorking.ProjectCode = d.data.ProjectCode;
                    this.formWorking.WMContent = d.data.WMContent;
                    this.formWorking.ID = d.data.ID;
                    this.formWorking.WMDateTime = d.data.WMDateTime;
                    this.formWorking.State = d.data.State;
                    this.formWorking.Code = d.data.Code;
                    this.formWorking.Duration = d.data.Duration;
                    this.formWorking.approvalContent = d.data.approvalContent;
                    this.formWorking.activity = d.data.activity;
                    let startTime = this.$moment(d.data.StartTime)
                    let endTime = this.$moment(d.data.EndTime)
                    this.formWorking.StartTime = startTime.format("YYYY-MM-DD")
                    if(startTime.minute() == 0){
                        this.formWorking.timeFrom = startTime.hour() * 10
                    } else {
                        this.formWorking.timeFrom = startTime.hour() * 10 + 5
                    }

                    if(endTime.minute() == 0){
                        this.formWorking.timeTo = endTime.hour() * 10
                    } else {
                        this.formWorking.timeTo = endTime.hour() * 10 + 5
                    }
                });
            } else if(date){
                // var Month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
                // var data = date.getFullYear() + '-' + Month + '-' + date.getDate();
                //给开始时间和结束时间赋默认值
                this.formWorking.StartTime = this.$moment(date).format("YYYY-MM-DD");
                // this.formWorking.EndTime = data + ' 00:00:00';
            } else {
                //获取当前时间
                // var aData = new Date();
                // var Month = aData.getMonth() + 1 > 9 ? aData.getMonth() + 1 : '0' + (aData.getMonth() + 1);
                // var data = aData.getFullYear() + '-' + Month + '-' + aData.getDate();
                // //给开始时间和结束时间赋默认值
                // this.formWorking.StartTime = data + ' 00:00:00';
                // this.formWorking.EndTime = data + ' 00:00:00';
                this.formWorking.StartTime = this.$moment(new Date()).format("YYYY-MM-DD");
            }
            //显示弹出层
            this.openWorking = true;
        },
        // 回调
        deleteItem(id){
            console.log("deleteItem:" + id)
            this.$axios.post('/api/Working/DeleteWorkingData?ID=' + id ).then(res => {
                if(res.data.result){
                    this.$message.success(res.data.msg);
                    this.dateChange(this.calendarDate); //调用获取数据方法 (获取最新数据)
                    return
                }
                this.$message.error(res.data.msg);
            });
        },
        dateChange(date){
            this.calendarDate = date; //将日历的时间范围给保存
            if (this.UserInfo) {
                //获取工时信息
                this.$axios.get('/api/Working/GetWorkingMessage?start=' + this.dateFormat(date.start) + '&end=' + this.dateFormat(date.end)+'').then(d => {
                    this.calendarData = d.data;
                    //请求项目
                    this.$axios.get('/api/Working/GetAllProject').then(d => {
                        this.projects = d.data;
                    });
                });
            }
            else {
                //请求用户信息
                this.$axios.get('/api/Working/GetUserInfo').then(d => {
                    this.UserInfo = d.data;
                    this.formWorking.UserName = d.data.UserName;
                    this.formWorking.UserCode = d.data.UserCode;
                    this.formWorking.activity = d.data.Activity;
                    //获取工时信息
                    this.$axios.get('/api/Working/GetWorkingMessage?start=' + this.dateFormat(date.start) + '&end=' + this.dateFormat(date.end)+'').then(d => {
                        this.calendarData = d.data;
                        //请求项目
                        this.$axios.get('/api/Working/GetAllProject').then(d => {
                            this.projects = d.data;
                        });
                    });
                    //请求全部研发
                    this.$axios.get('/api/Working/GetAllUser').then(d => {
                        this.users = d.data;
                    });
                });
            }
        },

        /** 日期格式化 */
        dateFormat(date, fmt = "yyyy-MM-dd") {
            if (!date) return "";
            if (typeof(date) === 'string') {
                date = new Date(date.replace(/-/g, '/'));
            }
            const o = {
                "M+" : date.getMonth()+1,                 //月份
                "d+" : date.getDate(),                    //日
                "H+" : date.getHours(),                   //小时
                "m+" : date.getMinutes(),                 //分
                "s+" : date.getSeconds(),                 //秒
                "q+" : Math.floor((date.getMonth()+3)/3), //季度
                "S"  : date.getMilliseconds()             //毫秒
            };
            let _fmt = fmt;
            if(/(y+)/.test(fmt))
                _fmt = _fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
            for(const k in o)
                if(new RegExp("("+ k +")").test(_fmt))
                    _fmt = _fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
            return _fmt;
        },

        //关闭工时操作页面
        closeWorking() {
            this.clearForm();
            //关闭弹出层
            this.openWorking = false;
        },
         clearForm(){ //清空表单
            this.formWorking.UserName = this.UserInfo.UserName;
            this.formWorking.UserCode = this.UserInfo.UserCode;
            this.formWorking.activity = this.UserInfo.Activity;
            this.formWorking.StartTime ='';
            this.formWorking.EndTime = '';
            this.formWorking.timeFrom = '';
            this.formWorking.timeTo = '';
            this.formWorking.WMContent = '';
            this.formWorking.ID = '';
            this.formWorking.WMDateTime = '';
            this.formWorking.State = '';
            this.formWorking.Code = '';
            this.formWorking.Duration = 0;
            this.formWorking.approvalContent = '';
        },
        //添加——修改 工时
        operatingSubmitWorking() {
            //数据验证
            if(this.formWorking.State == 1){
                this.$message.error('工时已确认，不能修改');
                return false;
            }
            if (this.isNull(this.formWorking.UserName)) {
                this.$message.error('姓名,不可以为空');
                return false;
            }
            if (this.isNull(this.formWorking.StartTime)) {
                 this.$message.error('开始时间,不可以为空');
                return false;
            }
            if (this.isNull(this.formWorking.WMContent)) {
                this.$message.error('工作内容,不可以为空');
                return false;
            }
            if (this.isNull(this.formWorking.ProjectCode)) {
                 this.$message.error('请选择项目');
                return false;
            }
            if(this.formWorking.Duration <= 0){
                this.$message.error('工时错误')
                return false;
            }


            //请求后台 —— 操作工时信息
            var data = JSON.parse(JSON.stringify(this.formWorking))
            data.State = 0
            data.approvalContent = ""
            let date = this.$moment(this.formWorking.StartTime).format("YYYY-MM-DD")
            let timeFrom = ""
            if(this.formWorking.timeFrom % 10 == 0){
                timeFrom = this.formWorking.timeFrom / 10 + ":00:00"
            } else {
                timeFrom = Math.floor(this.formWorking.timeFrom / 10) + ":30:00"
            }
            data.StartTime = date + " " + timeFrom

            let timeTo = ""
            if(this.formWorking.timeTo % 10 == 0){
                timeTo = this.formWorking.timeTo / 10 + ":00:00"
            } else {
                timeTo = Math.floor(this.formWorking.timeTo / 10) + ":30:00"
            }
            data.EndTime = date + " " + timeTo
            this.$axios.post('/api/Working/operatingWorking', data).then(res => {
               if(res.data.result){
                this.$message.success(res.data.msg);
                this.dateChange(this.calendarDate); //调用获取数据方法 (获取最新数据)
                this.closeWorking(); //关闭弹出层
                return
               }
                this.$message.error(res.data.msg);
            });
        },
        isNull(item){ //判读是否为空
            if(item!='' && item != 'undefined' && item !=null) return false;
                return true;
        },
        WorkingApprove(item) //工时操作方法
        {
            this.$axios.get('/api/Working/WorkingApprove?ID='+item).then(res => {
               if(res.data.result){
                this.$message.success(res.data.msg);
               }
               else{
                this.$message.error(res.data.msg);
               }
            });

        }


    }
};
</script>

<style lang="scss">
html,
body {
    background-color: #e5e5e5;
}
.home {
    display: inline-block;
    min-height: 700px;
    background-color: white;
    width: 80%;
}
.ant-form-item {
    margin-bottom: 5px !important;
}
.warning {
    color: Red;
    font-size: 14px;
    margin-bottom: 20px;
}
li[type='1']::before {
    background-color: #1d953f !important;
}
li[type='0']::before {
    background-color: #8b8b8a !important;
}
li[type='-1']::before {
    background-color: #ec5656 !important;
}
</style>
